import { toBinary } from '@bufbuild/protobuf'

import type { PathItem as PathItemConnect } from '@jotta/grpc-connect-openapi/file'
import { PathItemSchema } from '@jotta/grpc-connect-openapi/file'
import {
  ItemAction,
  PathItem,
} from '@jotta/grpc-web/no/jotta/openapi/file/file.v2_pb'
import type { PathItemObject } from '@jotta/types/Files'
import { getItemActionKey } from '@jotta/types/schemas/FileActionSchema'
import { addUrlParams } from '@jotta/utils/url'

export interface ParsePathItemParams {
  pathItem: PathItem
  additionalChildren?: PathItem[]
  token?: string
  ignoreChildren?: boolean
  ignoreDownloadLinks?: boolean
  responseCursor?: string
  isSearchResult?: boolean
}

export function parsePathItem(params: ParsePathItemParams): PathItemObject {
  const {
    additionalChildren,
    pathItem,
    token,
    ignoreChildren,
    ignoreDownloadLinks,
    responseCursor,
    isSearchResult = false,
  } = params

  if (/^\/(backup|photos|contacts)($|\/)/i.test(pathItem.getPath())) {
    const EXCLUDED_ACTIONS = [ItemAction.ADD_CHILD]
    pathItem.setActionList(
      pathItem.getActionList().filter(a => !EXCLUDED_ACTIONS.includes(a)),
    )
  }

  const downloadLink = pathItem.getDownloadLink()
  // Clear all downloadLinks to get stable hashes
  pathItem.setDownloadLink('')

  if (!ignoreDownloadLinks && downloadLink) {
    pathItem.setDownloadLink(
      token
        ? addUrlParams(downloadLink, {
            access_token: token,
          })
        : downloadLink,
    )
  }

  const pathItemChildren = ignoreChildren
    ? []
    : [...pathItem.getChildrenList(), ...(additionalChildren ?? [])]

  pathItem.clearChildrenList() // This is to preserve the original functionality, which may be unintended.

  return {
    ...pathItem.toObject(),
    actions: pathItem.getActionList().map(action => getItemActionKey(action)),
    cursor: responseCursor,
    accessTokenOverride: token,
    childrenList: ignoreChildren
      ? []
      : pathItemChildren.map(item =>
          parsePathItem({ ...params, ignoreChildren: true, pathItem: item }),
        ),
    isSearchResult,
  }
}

export function convertToLegacyItem(item: PathItemConnect): PathItem {
  return PathItem.deserializeBinary(toBinary(PathItemSchema, item))
}
